module.exports = __webpack_public_path__ + "assets/img/2968282906f196da933cd89c22d657b0.svg";